import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';

@Component
export default class FormMixin extends Vue {

  @Prop({ default: ''})
  public placeholder: string

  @Prop({default: 'sm'})
  public size: string

  @Prop({default:''})
  public name: string

  @Prop({default:''})
  public id: string

  @Prop({ default: 0})
  public tabindex: number
}
